import { Component, Input } from "@angular/core";

@Component({
  selector: "page-card-item-line",
  template: "",
  standalone: false
})
export class PageCardItemLineComponent {
  @Input() icon!: string;
  @Input() text: string | null = null;
}
